import { useConnectors, useAccount } from "@starknet-react/core";
import { useState } from "react";
import argentLogo from '/home/nadai/Nadai App Starknet Test/src/components/argentLogo.svg'
import braavosLogo from '/home/nadai/Nadai App Starknet Test/src/components/braavosLogo.svg';
import { Alert } from 'react-bootstrap';
import { Button } from "react-bootstrap";
import ConnectionStatus from "./ConnectionStatus";


export default function ConnectWallet() {
  const { connect, disconnect, connectors } = useConnectors();
  const { status } = useAccount();
  const [connected, setConnected] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [showWarning, setShowWarning] = useState(false);

  function handleConnect(walletType) {
    return new Promise(async (resolve, reject) => {
      resolve(await connect(await connectors[walletType]));
      reject("User Cancelled");
    });
  }

  function handleDisconnect() {
    disconnect();
    setConnected(false);
  }

  return (
    <div>    
      <div className="d-grid gap-2 login-btn-container">
      {showWarning && <Alert variant="danger">Va a conectar su billetera, está dando permiso para que Nadai Starknet dApp interactúe con su billetera.</Alert>}
        <img
          src={argentLogo}
          alt="Argent"
          onClick={() => {
            setShowWarning(true);
            setTimeout(() => {
              setShowWarning(false);
              handleConnect(1).then(
                (value) => {
                  if (status === "connected") {
                    setConnected(true);
                    setShowMenu(false);
                  }
                },
                (error) => {
                  console.log(error);
                }
              );
            }, 4000);
          }}
        />
        <img
          src={braavosLogo}
          alt="Braavos"
          onClick={() => {
            setShowWarning(true);
            setTimeout(() => {
              setShowWarning(false);
              handleConnect(0).then(
                (value) => {
                  if (status === "connected") {
                    setConnected(true);
                    setShowMenu(false);
                  }
                },
                (error) => {
                  console.log(error);
                }
              );
            }, 4000);
          }}
        />
      </div>
      <Button className="login-btn address" onClick={() => setShowMenu(!showMenu)}>
        <ConnectionStatus connected={connected} />
      </Button>
     {connected && <Button className="disconnect-btn" onClick={handleDisconnect}>Disconnect</Button>}

</div>

);
}
